import { t } from "@lingui/macro";
import { BlurTargetView, BlurView } from "expo-blur";
import { useRef } from "react";
import { ImageBackground, StyleSheet, View } from "react-native";

import { Button } from "@whoosh/design-system/src/components/controls";
import { InfoBanner } from "@whoosh/design-system/src/components/display/InfoBanner/InfoBanner";
import { AlertIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { PoweredByWhooshStacked } from "@whoosh/design-system/src/components/icons_v2/special/PoweredByWhooshStacked";
import {
  Box,
  VStack,
  Text,
  HStack,
} from "@whoosh/design-system/src/components/primitive";
import { images } from "@whoosh/design-system/src/theme/images";

import { openExternalLink } from "../openExternalLink";

export const AppUpdateFullScreenBanner = ({
  updateUrl,
}: {
  updateUrl: string;
}) => {
  const blurTargetRef = useRef<View | null>(null);

  return (
    <View style={{ flex: 1 }}>
      <BlurTargetView ref={blurTargetRef} style={{ flex: 1 }}>
        <ImageBackground
          source={images.initialBackground}
          resizeMode="cover"
          style={{ flex: 1 }}
        />
      </BlurTargetView>
      <BlurView
        blurMethod="dimezisBlurViewSdk31Plus"
        blurTarget={blurTargetRef}
        intensity={100}
        style={StyleSheet.absoluteFill}
      >
        <VStack
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          backgroundColor={"surface-overlay"}
          opacity={0.2}
        />
        <VStack
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          paddingHorizontal={6}
          style={{
            paddingTop: "40%",
          }}
        >
          <VStack
            backgroundColor={"surface-primary"}
            borderRadius={"4"}
            padding={4}
          >
            <HStack justifyContent={"flex-end"} alignContent={"center"} mb={8}>
              <PoweredByWhooshStacked />
            </HStack>
            <VStack mb={16}>
              <Text mb={6} variant={"mainTitle2"}>
                {t`New Update Available`}
              </Text>
              <Text>{t`We know you love updating your apps as much as we do!`}</Text>
            </VStack>
            <Box width="100%">
              <InfoBanner
                leadingIcon={AlertIcon}
                message={t`Update Required To Continue`}
                colorTheme={"WARNING"}
              />
              <Box height={8} />
              <Button
                onPress={() => {
                  openExternalLink(updateUrl);
                }}
                accessibilityLabel={t`Download Update button`}
              >
                {t`Download Update`}
              </Button>
            </Box>
          </VStack>
        </VStack>
      </BlurView>
    </View>
  );
};
